import omit from 'lodash/omit';
import uniq from 'lodash/uniq';

export default class FormDataParser {
  constructor(formElement, options = {}) {
    this.inputSelector =
      'input:not([data-no-summary]), select:not([data-no-summary]), textarea:not([data-no-summary])';
    this.$form = $(formElement);
    this.summary = {};
    this.options = options;
  }

  static _getDisplayText($elem) {
    const text =
      $elem.data('summary-display') || $elem.text() || $elem.val() || '';
    return text.toString().trim();
  }

  _getInputs() {
    this.$inputs = $(this.inputSelector, this.$form);
  }

  _getDisplay($input) {
    const isSelect = $input.is('select');
    const isCheckbox = $input.is(':checkbox');
    const isRadio = $input.is(':radio');

    if (!isSelect && !isCheckbox && !isRadio) {
      return FormDataParser._getDisplayText($input);
    }

    if (isSelect) {
      return $input
        .find(':selected')
        .toArray()
        .map(option => FormDataParser._getDisplayText($(option)));
    }

    const display = this.$form
      .find(`[name="${$input.attr('name')}"]:checked`)
      .toArray()
      .map(input => FormDataParser._getDisplayText($(input)));

    return uniq(display);
  }

  _getCheckedInputsByName(name) {
    return $(`[name="${name}"]:checked`, this.$form);
  }

  removeEmpty($input, render = true) {
    const name = $input.attr('name');
    const value = $input.val();
    const item = this.summary[name];
    const display = this._getDisplay($input);

    if (!item) {
      return;
    }

    if (item.isCheckable && item.isMultiple) {
      const index = item.value.indexOf(value.toString());

      if (index > -1) {
        this.summary[name].value.splice(index, 1);
        this.summary[name].display = display;

        if (!this.summary[name].value.length) {
          this.summary = omit(this.summary, name);
        }
      }
    } else {
      this.summary = omit(this.summary, name);
    }

    if (render) {
      this.render();
    }
  }

  change(element, render = true) {
    const $input = $(element);
    const isCheckable = $input.is(':checkbox') || $input.is(':radio');
    const isCheckbox = $input.is(':checkbox');
    const isRadio = $input.is(':radio');
    const name = $input.attr('name');
    const isEmpty = !$input.val() || $input.val().toString().length <= 0;
    const isMultiple =
      $input.attr('multiple') !== undefined || $input.is(':checkbox');
    const hasKey = !!this.summary[name];
    const display = this._getDisplay($input);

    if (
      !hasKey &&
      ((!isCheckable && isEmpty) || (isCheckable && !$input.is(':checked')))
    ) {
      if (render) {
        this.render();
      }
      return;
    }

    if (
      $input.is('[type=text], [type=search], textarea') &&
      $input.attr('minlength') &&
      Number($input.val().trim().length) < Number($input.attr('minlength'))
    ) {
      return;
    }

    if (
      hasKey &&
      $input.is('[type=text], [type=search], textarea') &&
      (!$input.val() || $input.val().trim() === '')
    ) {
      return this.removeEmpty($input, render);
    }

    if (hasKey && isCheckbox && !$input.is(':checked')) {
      return this.removeEmpty($input, render);
    }

    if (hasKey && isRadio && !this._getCheckedInputsByName(name).length) {
      return this.removeEmpty($input, render);
    }

    let value = $input.val();

    if (isMultiple && isCheckable) {
      value = this._getCheckedInputsByName(name)
        .toArray()
        .map(x => x.value.toString());
      value = uniq(value);
    }

    this.summary[name] = {
      name: name,
      value: value,
      display: display,
      label: $input.data('summary-label'),
      isCheckable: isCheckable,
      isMultiple: isMultiple,
      isSelect: !!$input.is('select')
    };

    if (render) {
      this.render();
    }
  }
}
